import { ComponentProps } from "react";

import { LadySliderModal } from "./LadySlider.modal";
import { SliderContextProvider } from "./context/Slider.context";

export const LadySliderContextWrapper: React.FC<
  ComponentProps<typeof LadySliderModal>
> = ({ ...rest }) => {
  return (
    <SliderContextProvider
      initialIndex={rest.initialIndex}
      mediaLength={rest.media?.length ?? 0}
    >
      <LadySliderModal {...rest} />
    </SliderContextProvider>
  );
};
